import { useEffect } from 'react'

import { TableNode } from '@lexical/table'
import { $wrapNodeInElement } from '@lexical/utils'
import { $getNodeByKeyOrThrow } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import { useMutationListener } from '../../hooks/useMutationListener'
import { $createTableControllerNode } from '../../nodes/TableControllerNode'
import {
  $createTableWrapperNode,
  $isTableWrapperNode,
  TableWrapperNode
} from '../../nodes/TableWrapperNode'
import { $findParentNodeOrThrow } from '../../utils/node'

const TABLE_WRAPPER_NODE_MAP = new Map<string, TableWrapperNode>()

export const TableWrapperPlugin = () => {
  const editor = useEditor()

  // 插入自定义节点
  useEffect(() => {
    return editor.registerNodeTransform(TableNode, tableNode => {
      const parentNode = tableNode.getParentOrThrow()
      if ($isTableWrapperNode(parentNode)) {
        return
      }
      $wrapNodeInElement(tableNode, () => {
        const wrapperNode = $createTableWrapperNode()
        const controllerNode = $createTableControllerNode()
        wrapperNode.append(controllerNode)
        return wrapperNode
      })
    })
  }, [editor])

  useMutationListener(TableNode, 'created', tableNodeKey => {
    editor.getEditorState().read(() => {
      const tableNode = $getNodeByKeyOrThrow(tableNodeKey)
      const tableWrapperNode = $findParentNodeOrThrow(
        tableNode,
        $isTableWrapperNode
      )
      TABLE_WRAPPER_NODE_MAP.set(tableNodeKey, tableWrapperNode)
    })
  })

  // TableNode 移除时把 wrapperNode 也移除
  useMutationListener(TableNode, 'destroyed', tableNodeKey => {
    const tableWrapperNode = TABLE_WRAPPER_NODE_MAP.get(tableNodeKey)
    if (tableWrapperNode) {
      TABLE_WRAPPER_NODE_MAP.delete(tableNodeKey)
      editor.update(() => {
        if (tableWrapperNode.isAttached()) {
          tableWrapperNode.remove()
        }
      })
    }
  })

  return null
}
